import { createCtx } from '@shared/util/context';
import { State as StateContext, initialState } from './reducer';

interface ActionsContext {
  addCard(card: MBAPI.Card): void;
  removeCard(card: MBAPI.Card): void;
  removeCardById(id: MBAPI.Scalar.UUID): void;
  loadingCards: MBAPI.Scalar.UUID[];
  setLoadingCard: (id: MBAPI.Scalar.UUID, isLoading: boolean) => void;
  setActive(value: boolean): void;
  reset(): void;
}

export const [useCardSelectionState, CardSelectionStateProvider] =
  createCtx<StateContext>(initialState);

export const [useCardSelectionActions, CardSelectionActionsProvider] = createCtx<ActionsContext>({
  addCard: () => {},
  removeCard: () => {},
  removeCardById: () => {},
  loadingCards: [],
  setLoadingCard: () => {},
  setActive: () => {},
  reset: () => {},
});
